import { tDiscountPercent } from "../../interfaces";
import { eAppActionTypes } from "../../store/app/appTypes";
import { store } from "../../store/store";
import { getHumanDate } from "../helpers";
import { getTimeQuery } from "./queries";

export const getTime = async (percent?: tDiscountPercent) => {
	const {discountPercent} = store.getState().app;
	const finalPercent = percent || discountPercent;

	const nowTs = await getTimeQuery();
	store.dispatch({
		type: eAppActionTypes.SET_CURRENT_TIME,
		payload: {
			percent: finalPercent,
			time: {
				ts: +nowTs,
				formatted: getHumanDate(+nowTs, 'YYYY-MM-DD hh:mm'),
			}
		}
	})
}